import type { FaireProductEntity } from "../../entity_types/product";

export const p_wjc5jdg44n: FaireProductEntity = {
  token: "p_wjc5jdg44n",
  type: "product",
  name: "Brooklyn - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/4f43948e635fe843a1964a19dac1a4a4999ee27cad900cd1a3b8d57fb1d23775.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b832f5f8b4f43d059df9a51a52a3943d199b38f18bc9fc85537157a1581ea4f4.jpeg",
    "https://cdn.faire.com/fastly/9b8debb24129c023f17569b3bb9ee2003b2429783873143d3a93fa21abb56a6c.jpeg",
    "https://cdn.faire.com/fastly/c560ab4e40d654ab48f67287831e5597f530ac2b31e9898889f63e569adcbb28.jpeg",
    "https://cdn.faire.com/fastly/33b87f6508c537203066f41531d778838e30443c464f67923fdc1d6c3068c5c7.jpeg",
  ],
  priceDollars: 10.92,
  description:
    "A perennial filter classic, we use the Brooklyn blend as our go-to coffee of the day. Brimming with flavors of creamy cocoa, sweet toffee and rich dried fruits, this offering brews beautifully on the French Press at home and is equally tasty with or without milk.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Producers Pedro Echavarria, Paz Family and Josue Morales\n• Tasting Notes Milk Chocolate, Toffee and Dried Fruit\n• Elevation 1,600 - 1,900 meters\n• Regions Antioquioa, Colombia, Santa Barbara, Honduras and Santa Rosa, Guatemala\n• Variety Various\n• Process Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\n• Yes\n\nPerfect For: Father's Day gifting",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:11.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
